import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/temperature-conversion',
  component: () => import('../../routes/TemperatureConversion.svelte'),
  card: {
    id: 'temperature-conversion',
    title: 'Temperature Conversion',
    description: 'Convert temperatures between Celsius, Fahrenheit, Kelvin, and Rankine instantly.',
    icon: 'thermostat',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/temperature-conversion',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Temperature Conversion Calculator – °C to °F to K to °R',
    description: 'Free temperature conversion calculator. Instantly convert Celsius to Fahrenheit, Fahrenheit to Kelvin, and more. Supports Celsius, Fahrenheit, Kelvin, and Rankine scales.',
  },
};

export default meta;
